import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number5Circle"
const Number5CircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm2 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-11.22 5.65c-1.215 0-2.265-.435-3.18-1.35l1.38-1.29c.45.48 1.095.84 1.8.84.465 0 .915-.165 1.26-.48.36-.33.585-.81.585-1.35 0-.57-.24-1.08-.645-1.425-.33-.285-.78-.42-1.275-.42-.51 0-1.095.195-1.545.57l-1.26-.18L9.575 7h5.55v1.8h-3.9l-.165 1.65c.21-.045.525-.075.81-.075.81 0 1.71.195 2.445.795.825.66 1.335 1.725 1.335 2.85 0 2.07-1.755 3.63-3.87 3.63Z"
      />
    </svg>
  )
}
export default Number5CircleIcon
